import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { CollectionOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { COLLECTION_DEFAULT_TAB, COLLECTION_SHOW_TABS } from '../constants';
import { CollectionShowHeader } from './CollectionShowHeader';
import { CollectionGeneralTab } from './CollectionGeneralTab';
import { CollectionCollectionTab } from './CollectionCollectionTab';
import { SearchPopularityCard } from '@/components/common/show/SearchPopularityCard';
import { CollectionPublicationsTable } from '@/components/user_catalog/collections/CollectionPublicationsTable';

export const CollectionShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<CollectionOut>({
    resource: 'user_catalog.collections',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('user_catalog.collections', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    COLLECTION_SHOW_TABS,
    COLLECTION_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <CollectionShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <CollectionGeneralTab record={record} />
            )}
            {activeTab === 'publications' && (
              <CollectionPublicationsTable
                collectionId={record.id}
                collectionKind={record.collection_kind}
              />
            )}
            {activeTab === 'collection' && (
              <CollectionCollectionTab record={record} />
            )}
            {activeTab === 'search' && (
              <SearchPopularityCard value={record.search_popularity} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
